module.exports = __webpack_public_path__ + "img/trx.39d11654.svg";